var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "action",
      style: _vm.actionStyle,
      on: { click: _vm.onClick },
    },
    [_c("li", { class: _vm.icon, style: _vm.iconStyle })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }